import { defineComponent as _defineComponent } from 'vue'
import BaseEditableCard from "@/components-UI/BaseEditableCard.vue";

interface Props {
    isLoading?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ContestOfferCard',
  props: {
    isLoading: { type: Boolean, default: false }
  },
  setup(__props: any) {



return { __sfc: true,BaseEditableCard }
}

})